module.exports = __webpack_public_path__ + "static/img/ExoOPS™ - Mission Design presentation.53e67d4.png";